import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WaitlistForm = ({ source = "hero", light = false }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/waitlist`, { email, source });
      setDone(true);
      toast.success("You're on the list. We'll be in touch soon.");
    } catch (err) {
      if (err.response?.status === 409) {
        setDone(true);
        toast.info("You're already on the waitlist.");
      } else {
        toast.error(err.response?.data?.detail?.[0]?.msg || "Please enter a valid email.");
      }
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div
        data-testid={`waitlist-success-${source}`}
        className={`flex items-center gap-3 rounded-full px-6 py-4 text-sm font-medium ${light ? "bg-white/10 text-white" : "bg-[#E8EDFF] text-[#2A46B5]"}`}
      >
        <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#3B5FE8] text-white"><Check size={14} /></span>
        You're on the waitlist — early access is coming your way.
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="flex w-full max-w-md flex-col gap-3 sm:flex-row" data-testid={`waitlist-form-${source}`}>
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Work email"
        data-testid={`waitlist-email-input-${source}`}
        className={`h-13 flex-1 rounded-full border px-6 py-3.5 text-sm outline-none transition-colors duration-200 ${
          light
            ? "border-white/20 bg-white/10 text-white placeholder:text-white/50 focus:border-white/50"
            : "border-slate-200 bg-white text-slate-900 placeholder:text-slate-400 focus:border-[#3B5FE8]"
        }`}
      />
      <button
        type="submit"
        disabled={loading}
        data-testid={`waitlist-submit-${source}`}
        className="btn-primary group flex items-center justify-center gap-2 whitespace-nowrap px-7 py-3.5 text-sm font-semibold disabled:opacity-60"
      >
        {loading ? "Joining…" : "Join the waitlist"}
        <ArrowRight size={16} className="transition-transform duration-200 group-hover:translate-x-0.5" />
      </button>
    </form>
  );
};
